import type { ReactNode } from 'react';

interface TableCellProps {
    hidden?: boolean;
    className?: string;
    isSorted?: boolean;
    children: ReactNode;
}

const TableCell = ({ hidden = false, className, isSorted = false, children }: TableCellProps) => {
    if (hidden) {
        return null;
    }

    const cellClassName = `${className ?? ''} ${isSorted ? 'sorted' : ''}`.trim();

    return <td className={cellClassName || undefined}>{children}</td>;
};

export default TableCell;
